import { Button, Stack, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { DialogContainer, DialogHeader } from "../../../components/exports";
import { SatisfactionConstants } from "../../../constants/SatisfactionConstants";
import { DialogContext } from "../../../contexts/DialogueContext";
import Satisfaction from "../components/Satisfaction";

export default function SupportOperatorSurveyDialog(props: { id: string }) {
    const [result, setResult] = useState<number | null>(null);
    const [requestInProgress, setRequestInProgress] = useState(false);

    const { closeDialog } = useContext(DialogContext);

    useEffect(() => {
        // SurveyService.ignoreSurvey(Number(props.id), "1").then();
    }, []);

    const submitRating = () => {
        setRequestInProgress(true);
        // SurveyService.takeSurvey(Number(props.id), "1", {
        //     result: result,
        // }).finally(() => {
        //     setRequestInProgress(false);
        //     closeDialog(true);
        // });
    };

    return (
        <DialogContainer>
            <DialogHeader title="نظرسنجی" />

            <Stack spacing={3} sx={{ p: 2 }}>
                <Typography>
                    لطفا میزان رضایت خود را از مکالمه با پشتیبانی پرشین سازه
                    اعلام نمایید، نظرات شما حتما در تصمیمات ما تاثیر گذار خواهد
                    بود.
                </Typography>

                <Stack direction="row" justifyContent="space-between">
                    {SatisfactionConstants.map((s) => {
                        return (
                            <Satisfaction
                                key={s.value}
                                item={s}
                                selectedValue={result}
                                onSelect={setResult}
                            />
                        );
                    })}
                </Stack>

                <Button
                    fullWidth
                    onClick={submitRating}
                    variant="contained"
                    disabled={requestInProgress || !result}
                >
                    ارسال نظرسنجی
                </Button>
            </Stack>
        </DialogContainer>
    );
}
